import ClipboardJS from 'clipboard'

class FileUrlReferenceClipboard {
  constructor({ className, text, onSuccessCallback }) {
    this.onSuccessCallback = onSuccessCallback
    this.clipboard = new ClipboardJS(className, {
      text() {
        return text
      },
    })
    this.onSuccess()
  }

  onSuccess() {
    const self = this
    this.clipboard.on('success', (e) => {
      self.onSuccessCallback()
      e.clearSelection()
    })
  }
}

export default FileUrlReferenceClipboard
